import React, { useState } from 'react'
import {
  CAlert,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormCheck,
  CLoadingButton,
  CRow,
} from '@coreui/react-pro'
import ToastComponent from 'src/components/common/TaostComponent'
import GeneralService from 'src/service/GeneralService'

// value: current game_point_system_type (0=position-based, 1=unified)
// onSaved: callback(newValue) called after a successful save
const PointSystemType = ({ value, onSaved, teamView, fixtureExists }) => {
  const [selected, setSelected] = useState(value ?? 0)
  const [loader, setLoader] = useState(false)

  // Keep local state in sync when parent value changes (e.g. after fetch completes)
  React.useEffect(() => {
    setSelected(value ?? 0)
  }, [value])

  const handleSubmit = () => {
    setLoader(true)
    GeneralService.updateGamePointSystemType({ game_point_system_type: selected })
      .then((res) => {
        setLoader(false)
        if (res.status === 200) {
          ToastComponent(res.message, 'success')
          onSaved?.(selected)
        }
      })
      .catch((e) => {
        setLoader(false)
        ToastComponent(e.response?.data?.message || 'Something went wrong.', 'error')
      })
  }

  return (
    <CRow>
      <CCol xs={12}>
        <CAlert color="success">
          <strong>
            {teamView === 1 ? 'This is a Position-Free game.' : 'This is a Position-Based game.'}
          </strong>
        </CAlert>
        <CCard className="mb-4">
          <CCardHeader>
            <strong>Point System Settings</strong>
          </CCardHeader>
          <CCardBody>
            <p className="mb-3">Select the type of point system to use for the game:</p>
            <CFormCheck
              type="radio"
              name="pointSystemType"
              id="positionBased"
              label="Position-Based Point System"
              checked={selected === 0}
              onChange={() => setSelected(0)}
              disabled={fixtureExists !== 0}
              className="mb-2"
            />
            <CFormCheck
              type="radio"
              name="pointSystemType"
              id="unified"
              label="Unified Point System"
              checked={selected === 1}
              onChange={() => setSelected(1)}
              disabled={fixtureExists !== 0}
              className="mb-3"
            />
            {fixtureExists === 0 && (
              <CLoadingButton color="success" loading={loader} onClick={handleSubmit}>
                Submit
              </CLoadingButton>
            )}
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  )
}

export default PointSystemType
